import React from 'react';
import { Button } from 'components';
import { sizes } from 'assets';
import styles from './TableHeader.module.scss';
import { ProjectsTableState } from '../ProjectsTable';

interface Props extends ProjectsTableState {
  setState: (obj: object) => void;
  flatTable?: boolean;
}

const TableHeader = (props: Props) => {
  const {
    arrangeByName, arrangeByType, arrangeByAddedDate,
    arrangeByGenre, arrangeOrder, setState, flatTable
  } = props;
  const tableHeaderStyles = [styles.tableHeader];
  flatTable && tableHeaderStyles.push(styles.flatStyles);

  return (
    <div className={tableHeaderStyles.join(' ')}>
      <Button
        className={styles.tableHeaderBttn}
        style={{ width: sizes.projectsTableTitleWidth }}
        onClick={() => setState(s => ({
          ...s,
          arrangeByName: arrangeByName === 'ascending' ? 'descending' : 'ascending',
          arrangeOrder: ['name', [...arrangeOrder.filter(value => value !== 'name')]]
        }))}
      >
        {
          // flatTable
          //   ? 'title'
          //   : `title ${arrangeByName === 'ascending' ? '▼' : '▲'}`
          `title ${arrangeByName === 'ascending' ? '▼' : '▲'}`
        }
      </Button>

      <Button
        className={styles.tableHeaderBttn}
        style={{ width: sizes.projectsTableTypeWidth }}
        onClick={() => setState(s => ({
          ...s,
          arrangeByType: arrangeByType === 'ascending' ? 'descending' : 'ascending',
          arrangeOrder: ['type', [...arrangeOrder.filter(value => value !== 'type')]]
        }))}
      >
        {
          `type ${arrangeByType === 'ascending' ? '▼' : '▲'}`
        }
      </Button>

      <Button
        className={styles.tableHeaderBttn}
        style={{ width: sizes.projectsTableAddedAtWidth }}
        onClick={() => setState(s => ({
          ...s,
          arrangeByAddedDate: arrangeByAddedDate === 'ascending' ? 'descending' : 'ascending',
          arrangeOrder: ['date', [...arrangeOrder.filter(value => value !== 'date')]]
        }))}
      >
        {
          // flatTable
          //   ? 'added at'
          //   : `added at ${arrangeByAddedDate === 'ascending' ? '▼' : '▲'}`
          `added at ${arrangeByAddedDate === 'ascending' ? '▼' : '▲'}`
        }
      </Button>

      {/* <Button
        className={[styles.tableHeaderBttn, styles.inactiveBttn].join(' ')}
        style={{ width: sizes.projectsTableViewsWidth }}
      >
        views
      </Button> */}

      <Button
        className={[styles.tableHeaderBttn, styles.inactiveBttn].join(' ')}
        style={{ width: sizes.projectsTableTagsWidth }}
      >
        tags
      </Button>

      <Button
        className={styles.tableHeaderBttn}
        style={{ width: sizes.projectsTableGenreWidth }}
        onClick={() => setState(s => ({
          ...s,
          arrangeByGenre: arrangeByGenre === 'ascending' ? 'descending' : 'ascending',
          arrangeOrder: ['genre', [...arrangeOrder.filter(value => value !== 'genre')]]
        }))}
      >
        {
          // flatTable
          //   ? 'genre'
          //   : `genre ${arrangeByGenre === 'ascending' ? '▼' : '▲'}`
          `genre ${arrangeByGenre === 'ascending' ? '▼' : '▲'}`
        }
      </Button>

      <Button
        className={[styles.tableHeaderBttn, styles.inactiveBttn].join(' ')}
        style={{ flex: 1 }}
      >
        status
      </Button>
    </div>
  );
};

export default TableHeader;
